import {
  buildChartCalculationPayload,
  buildChartHandlerRegistry,
  CHART_CALCULATION_TIMEOUT_MS,
  createChartCalculationDispatcher,
  type TChartCalculationHandler,
} from '@dbl/services/common/chartCalculationCore';
import { type TChartType } from '@dbl/core/chart';
import {
  transformPreviewSqlResponseDtoToVo,
  type IPreviewSqlVo,
} from '@dbl/services/dataSource';
import { datalabWithTokenHttp, type TDatalabHttpConfig } from '@dbl/services/common';

import { dashboardChartConfigByType } from './config';
import type { IDashboardChartRequest } from './types';

/** 报表页通用图表计算回退接口（未命中专用 chartType 时使用）。 */
export const getDashboardChartLegacy: TChartCalculationHandler<IDashboardChartRequest> = (
  param,
) =>
  datalabWithTokenHttp({
    url: '/api/v1/datalab/getChartAnalysis',
    method: 'post',
    data: buildChartCalculationPayload(param),
    timeout: CHART_CALCULATION_TIMEOUT_MS,
  } as TDatalabHttpConfig);

const dashboardChartHandlerRegistry =
  buildChartHandlerRegistry<IDashboardChartRequest>(dashboardChartConfigByType);

/**
 * 根据图表类型分发执行报表页图表计算请求（dashboard_chart_* 系列）。
 * 未命中专用映射时，回退至 getChartAnalysis 通用接口。
 */
export const calculateDashboardChart = createChartCalculationDispatcher({
  registry: dashboardChartHandlerRegistry,
  fallback: getDashboardChartLegacy,
});

/**
 * 报表页预览 SQL：与 {@link calculateDashboardChart} 同接口，附加 is_sql_preview=true。
 */
export const previewDashboardChartSql = (
  chartType: TChartType,
  params: IDashboardChartRequest,
): Promise<IPreviewSqlVo> => {
  const taskId = params.task_id?.[0];

  return calculateDashboardChart(chartType, {
    ...params,
    is_sql_preview: true,
  }).then(raw => transformPreviewSqlResponseDtoToVo(raw, { taskId }));
};
